import { Energy_Village__Tipo_Feedback_Enum, FeedbackQuery } from "../../_graphql/generated";


export type FeedbackState = {
  loading: boolean;
  data?: FeedbackQuery['energy_village_feedback'];
  type?: Energy_Village__Tipo_Feedback_Enum;
};

export const initialFeedbackState: FeedbackState = {
  loading: true,
  data: undefined,
  type: undefined
};
